import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { Utils } from '../../Utils/Utils';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelect, MultiSelectApi } from '../../Widgets/MultiSelect'
import { DateTimePickerApi } from '../../Widgets/DateTimePicker';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
var FILTER_DELIM = '-delim-';

var COLUMNS_INDEX = {
    Id: 0,
    GameName: 2,
    GameVariant: 3,
    Rtp: 4,
    Currency: 5,
    Customer: 6,
    Operation: 7,
    Jurisdiction: 8,
    Status: 9,
    ValidFrom: 10,
    ValidTo: 11
}

export interface GameConfigurationsPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlChangeStatus: string;
    urlRemoveValidity: string;
}

export class IndexPage extends PageBase<GameConfigurationsPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;
    private _form: JQuery;
    private _btnCancelSearch: JQuery;
    private _chckSelectAll: JQuery;

    private _filterGame: MultiSelectApi;
    private _filterCurrency: MultiSelectApi;
    private _filterCustomer: MultiSelectApi;
    private _filterOperation: MultiSelectApi;
    private _filterJurisdiction: MultiSelectApi;
    private _filterStatus: MultiSelectApi;
    private _filterValidFromFrom: DateTimePickerApi;
    private _filterValidFromTo: DateTimePickerApi;
    private _filterValidToFrom: DateTimePickerApi;
    private _filterValidToTo: DateTimePickerApi;

    constructor(options: GameConfigurationsPageOptions) {
        super(options);

        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);

        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.removeValidFrom = this.removeValidFrom.bind(this);
        this.removeValidTo = this.removeValidTo.bind(this);
        this.showSetValidity = this.showSetValidity.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this.showSetStatusEnable = this.showSetStatusEnable.bind(this);
        this.showSetStatusDisable = this.showSetStatusDisable.bind(this);

        window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;

        this._tableId = "tableGameConfigurations";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            pageLength: 20,
            lengthMenu: [[10, 20, 100, 500], [10, 20, 100, 500]],
            columns: [
                {
                    data: 'Id',
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<input id='chckbx${rowData.Id}' name='selectedConfig' value='${rowData.Id}' type='checkbox' onClick="setSelectAllCheckbox()" />`)
                },
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<a id='lnkDetail${rowData.Id}' href='${getDetailUrl(rowData)}'>Detail</a>`)
                },
                {
                    data: 'GameName',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCode${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "GameVariant",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnVariant${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "Rtp",
                    sortable: false,
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnRtp${rowData.Id}'>${data}</span>`),
                    defaultContent: ''
                },
                {
                    data: "CurrencyCode",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCurrency${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "CustomerName",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCustomer${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "OperationName",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnOperation${rowData.Id}'>${data}</span>`)
                },
                {
                    data: "JurisdictionName",
                    render: (data: any, type: any, rowData: any) => {
                        if (Utils.isNullOrUndefined(data)) {
                            return "";
                        }
                        return `<span id='spnJurisdiction${rowData.Id}'>${data}</span>`;
                    }
                },
                {
                    data: "DisplayStatus",
                    render: (data: any, type: any, rowData: any) => {
                        //var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = `status-${data.toLowerCase()}`;
                        return `<span id='spnState${rowData.Id}' class='${css}'>${data}</span>`;
                    }
                },
                {
                    data: "ValidFrom",
                    defaultContent: ''
                },
                {
                    data: "ValidTo",
                    defaultContent: ''
                }
            ],
            order: [[COLUMNS_INDEX.GameName, "asc"]],
            callbacks: {
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        this._form = Utils.getJQueryById("formGameConfigurations");
        this._btnCancelSearch = Utils.getJQueryById('btnCancelSearch');
        this._filterGame = new MultiSelectApi('filterGame');
        this._filterCurrency = new MultiSelectApi('filterCurrency');
        this._filterCustomer = new MultiSelectApi('filterCustomer');
        this._filterOperation = new MultiSelectApi('filterOperation');
        this._filterJurisdiction = new MultiSelectApi('filterJurisdiction');
        this._filterStatus = new MultiSelectApi('filterStatus');
        this._filterValidFromFrom = new DateTimePickerApi("filterValidFromFrom");
        this._filterValidFromTo = new DateTimePickerApi("filterValidFromTo");
        this._filterValidToFrom = new DateTimePickerApi("filterValidToFrom");
        this._filterValidToTo = new DateTimePickerApi("filterValidToTo");

        const btnEnableMulti = Utils.getJQueryById("btnEnableMulti");
        btnEnableMulti.on("click", this.showSetStatusEnable);

        const btnDisableMulti = Utils.getJQueryById("btnDisableMulti");
        btnDisableMulti.on("click", this.showSetStatusDisable);

        const btnRemoveValidFrom = Utils.getJQueryById("btnRemoveValidFrom");
        btnRemoveValidFrom.on("click", this.removeValidFrom);

        const btnRemoveValidTo = Utils.getJQueryById("btnRemoveValidTo");
        btnRemoveValidTo.on("click", this.removeValidTo);

        const btnSetValidity = Utils.getJQueryById("btnSetValidity");
        btnSetValidity.on("click", this.showSetValidity);

        this._chckSelectAll = Utils.getJQueryById("selectAll");
        this._chckSelectAll.on("change", this.checkBoxAll);

        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);
        this._form.on('submit', this.formSubmit);
        this._btnCancelSearch.on('click', this.cancelSearch);
    }

    private setSelectAllCheckbox(): void {
        var checkboxes = $("input[name='selectedConfig']");
        let selectAll = Utils.getJQueryById("selectAll")[0];
        if (Utils.isNullOrUndefined(selectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }
        (<HTMLInputElement>selectAll).checked = allCheckboxesChecked;
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedConfig']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._chckSelectAll[0]).checked;
        }
    }

    private deselectAll(): void {
        var checkboxes = $("input[name='selectedConfig']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = false;
        }
    }

    private showSetStatusEnable() {
        this.showSetStatus(true);
    }

    private showSetStatusDisable() {
        this.showSetStatus(false);
    }

    private showSetValidity() {
        $('#validitySettings').removeAttr("hidden");
    }

    private showSetStatus(status: boolean) {
        $('#statusSettings').removeAttr("hidden");
        $('#edStatus').prop("checked", status);
    }

    private removeValidFrom() {
        this.removeValidity("from");
    }

    private removeValidTo() {
        this.removeValidity("to")
    }

    private removeValidity(type: string) {
        $('#removeValiditySettings').removeAttr("hidden");
        $('#edValidityType').val(type);
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterCurrency.selectAll();
        this._filterGame.selectAll();
        this._filterCustomer.selectAll();
        this._filterOperation.selectAll();
        this._filterJurisdiction.selectAll();
        this._filterStatus.selectAll();
        this._filterValidFromFrom.clearDates();
        this._filterValidFromTo.clearDates();
        this._filterValidToFrom.clearDates();
        this._filterValidToTo.clearDates();
    }

    private preDrawCallback(datatable: DatatableApi): any {
        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.GameName).search(filterGame);
        var filterCurrency = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Currency).search(filterCurrency);
        var filterCustomer = this._filterCustomer.isAllSelected() ? '' : this._filterCustomer.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Customer).search(filterCustomer);
        var filterOperation = this._filterOperation.isAllSelected() ? '' : this._filterOperation.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Operation).search(filterOperation);
        var filterJurisdiction = this._filterJurisdiction.isAllSelected() ? '' : this._filterJurisdiction.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Jurisdiction).search(filterJurisdiction);
        var filterStatus = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMNS_INDEX.Status).search(filterStatus);

        var filterValidFromFrom = this._filterValidFromFrom.getUnixTimestamp();
        var filterValidFromTo = this._filterValidFromTo.getUTCDate();
        var filterValidFrom = filterValidFromFrom + FILTER_DELIM + filterValidFromTo;
        datatable.columns(COLUMNS_INDEX.ValidFrom).search(filterValidFrom);

        var filterValidToFrom = this._filterValidToFrom.getUnixTimestamp();
        var filterValidToTo = this._filterValidToTo.getUTCDate();
        var filterValidTo = filterValidToFrom + FILTER_DELIM + filterValidToTo;
        datatable.columns(COLUMNS_INDEX.ValidTo).search(filterValidTo);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/GameConfigurations/IndexPage.ts
 **/